import request from '../../util/request'
const baseURL = '/base-api'
export function sysWxActivityLogCode (parameter) {
  return request.post('/system/sysWxActivityLog/sendCode',parameter)
}
export function scanVoucher (parameter) {
  return request.get('/vat/scanVoucher/code',parameter)
}
export function sysWxActivityLogConfirm (parameter) {
  return request.post('/system/sysWxActivityLog/confirm',parameter)
}
export function sysWxActivityLogJoin (parameter) {
  return request.post('/system/sysWxActivityLog/join',parameter)
}
export function sysWxActivityLogCheckParticipated (parameter) {
  return request.get('/system/sysWxActivityLog/checkParticipated',parameter)
}
export function sysWxActivityLogCheckActivity (parameter) {
  return request.get('/system/sysWxActivityLog/checkActivity',parameter)
}
// 获取营销活动弹窗
export function getActivityModalList (params) {
  return request.service({
    url: `/business/merc/popMarket/list`,
    method: 'get',
    params,
    baseURL
  })
}



// WEBPACK FOOTER //
// ./src/api/active/index.js